import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/leistungen/shop-entwicklung")({
  beforeLoad: () => {
    throw redirect({
      to: "/leistungen/onlineshop-entwicklung",
      statusCode: 301,
    });
  },
  server: {
    handlers: {
      GET: async () => {
        return new Response(null, {
          status: 301,
          headers: { Location: "/leistungen/onlineshop-entwicklung" },
        });
      },
    },
  },
});
